import request from './handler'

const list = async params => {
  const { data } = await request.get('/kpi', { params })
  return data
}
const createKpi = form => request.post('/kpi', form)
const deleteKpi = (id) => request.delete(`/kpi?id=${id}`)
const updateSummaryKpi = (id, data) => request.put(`/kpi/summary?id=${id}`, data)
const getKpiDetail = async params => {
  const { data } = await request.get('/kpi/detail', { params })
  return data
}
const post = form => request.post('/kpi/detail', form)
const update = (id, data) => request.put(`/kpi/detail?id=${id}`, data)
const deleteDetail = (id) => request.delete(`/kpi/detail?id=${id}`)
const getObjectiveKpi = () => request.get('/objective')
const createObjective = form => request.post('/objective', form)
const deleteObjective = (id) => request.delete(`/objective?id=${id}`)
const getObjectiveEmployee = () => request.get('/objective/detail')
const postObjectiveEmployee = form => request.post('/objective/detail', form)
const deleteObjectiveEmployee = (id) => request.delete(`/objective/detail?id=${id}`)

export default {
  createKpi,
  update,
  updateSummaryKpi,
  getKpiDetail,
  post,
  deleteDetail,
  list,
  getObjectiveKpi,
  createObjective,
  deleteObjective,
  getObjectiveEmployee,
  postObjectiveEmployee,
  deleteKpi,
  deleteObjectiveEmployee
}
